import { APP_TYPES, BRAND } from '@config';

import { GeneralCalculationState, getGeneralCalcDefault } from './defaults/generalCalculation';
import { BracketAttachmentState } from './defaults/bracketAttachment';
import safetyBarrierDefault from './defaults/safetyBarrier';
import rebarReinforcementDefault from './defaults/rebarReinforcement';
import woodConnectionDefault from './defaults/woodConnection';

import {
  SET_PANEL_TYPE,
  SET_PANEL_CLOSE,
  DISABLE_PANEL_EDGE_DISTANCE,
  SET_PANEL_POSITION,
  SET_PANEL_DPL,
  SET_PANEL_LYH,
  SET_PANEL_DPP,
  SET_PANEL_WIDTH,
  SET_PANEL_HEIGHT,
  SET_PANEL_DEPTH,
  SET_DY,
  RESET_PANEL,
  SET_PANEL_OPTIONS,
  SET_COMPRESSION_OPTIONS,
  SET_PANEL_SIDE_LENGTH,
  SET_PANEL_STATE
} from '@reducers/options/panel/actions';

import merge from '@services/deepmerge';
import { mergeDeep } from '@services/helper.service';
import { brandList, countryList } from './../../../app.values';

export default (state = mergeDeep({}, GeneralCalculationState), action) => {
  switch (action.type) {
    case RESET_PANEL: {
      let options = state;
      let isImperial = BRAND === brandList.Redhead && Number(action.country) !== countryList.Canada;
      
      switch (action.appType) {
        case APP_TYPES.GENERAL_CALCULATION: {
          options = mergeDeep({}, getGeneralCalcDefault(isImperial));
          break;
        }
        case APP_TYPES.BRACKET_ATTACHMENT: {
          options = mergeDeep({}, BracketAttachmentState);
          break;
        }
        case APP_TYPES.SAFETY_BARRIER: {
          options = mergeDeep({}, safetyBarrierDefault);
          break;
        }
        case APP_TYPES.REBAR_REINFORCEMENT: {
          options = mergeDeep({}, rebarReinforcementDefault);
          break;
        }
        case APP_TYPES.WOOD_CONNECTION: {
          options = mergeDeep({}, woodConnectionDefault);
          break;
        }
        default: {
          break;
        }
      }

      return { ...options };
    }
    case SET_PANEL_STATE: {
      return action.state;  
    }
    case SET_PANEL_TYPE: {
      if (state.type !== action.panelType) {
        state.type = action.panelType;

        return { ...state };
      }

      return state;
    }
    case SET_PANEL_CLOSE: {
      state.isClosed = action.isClosed;

      return { ...state };
    }
    case DISABLE_PANEL_EDGE_DISTANCE: {
      state.disableEdgeDistance = action.isEdgeDistance;

      return { ...state };
    }
    case SET_PANEL_POSITION: {
      state.position = action.position;

      return { ...state };
    }
    case SET_PANEL_DPL: {
      return merge(state, { dpl: action.dpl });
    }
    case SET_PANEL_LYH: {
      return merge(state, { lyh: action.lyh });
    }
    case SET_PANEL_DPP: {
      return merge(state, { dpp: action.dpp });
    }
    case SET_PANEL_WIDTH: {
      state.width = action.value;

      return { ...state };
    }
    case SET_PANEL_HEIGHT: {
      state.height = action.value;

      return { ...state };
    }
    case SET_PANEL_DEPTH: {
      state.depth = action.value;

      return { ...state };
    }
    case SET_DY: {
      return merge(state, { dy: action.dy });
    }
    case SET_PANEL_OPTIONS: {
      return mergeDeep({}, state, action.options);
    }
    case SET_COMPRESSION_OPTIONS: {
      return mergeDeep({}, state, { compressionOptions: action.options });
    }
    case SET_PANEL_SIDE_LENGTH: {
      return mergeDeep({}, state, { sideLength: action.value });
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/reducers/options/panel/index.js